import axios from 'axios';
import { apiConfig } from '@/config/api';
import { authKeys } from '@/config/keys';
import { getAllCookies, type ParseCookiesContext } from '@/utils/cookies';
import { checkIsTokenValid } from '@/utils/jwt';
import { getCPFFromToken, getSubFromToken } from './util';

export function setupApiClient(
  ctx?: ParseCookiesContext,
  useAuthIdHeader: boolean = false
) {
  const api = axios.create({
    baseURL: apiConfig.baseURL,
  });

  api.interceptors.request.use((config) => {
    config.headers['Accept'] = 'application/json';
    config.headers['Content'] = 'application/json';

    const cookies = getAllCookies(ctx);

    const {
      [authKeys.authToken]: accessToken,
      [authKeys.authRefreshToken]: refreshToken,
    } = cookies;

    if (useAuthIdHeader) {
      config.headers['x-eqi-customer-id'] = getSubFromToken(accessToken);
      config.headers['x-eqi-customer-document'] = getCPFFromToken(accessToken);
    }

    const isTokenValid = checkIsTokenValid(accessToken);

    if (accessToken && isTokenValid) {
      config.headers['Authorization'] = `Bearer ${accessToken}`;
    } else if (refreshToken) {
      config.headers['Authorization'] = `Bearer ${refreshToken}`;
    }

    try {
      if (!accessToken) {
        const storedAccessToken = localStorage.getItem(authKeys.authToken);
        if (storedAccessToken) {
          config.headers['Authorization'] = `Bearer ${storedAccessToken}`;
        }
      }
    } catch (error) {}

    return config;
  });

  return api;
}
